import { render, staticRenderFns } from "./ApplyPrepayments.vue?vue&type=template&id=18c0eee0&scoped=true"
import script from "./ApplyPrepayments.vue?vue&type=script&lang=js"
export * from "./ApplyPrepayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0eee0",
  null
  
)

export default component.exports